import { ofType } from "redux-observable";
import { catchError, map, mergeMap, of } from "rxjs";
import {
  actionTypes,
  createOrUpdateRoleFailureAction,
  createOrUpdateRoleSuccessAction,
  createOrUpdateVisibilityConeFailureAction,
  createOrUpdateVisibilityConeSuccessAction,
  deleteRoleFailureAction,
  deleteRoleSuccessAction,
  deleteVisibilityConeFailureAction,
  deleteVisibilityConeSuccessAction,
  fetchAllUsersFailureAction,
  fetchAllUsersSuccessAction,
  fetchSelectableRolesFailureAction,
  fetchSelectableRolesSuccessAction,
  fetchUserRolesFailureAction,
  fetchUserRolesSuccessAction,
  getRoleUsersSelectedUsersFailureAction,
  getRoleUsersSelectedUsersSuccessAction,
  getRoleUsersUsersFailureAction,
  getRoleUsersUsersSuccessAction,
  loadRolesManagementRolesFailureAction,
  loadRolesManagementRolesSuccessAction,
  loadRolesManagementVisibilityConesFailureAction,
  loadRolesManagementVisibilityConesSuccessAction,
  loadRolesNewVisibilityConeFailure,
  loadRolesNewVisibilityConeSuccess,
  sendModifiedRolesFailureAction,
  sendModifiedRolesSuccessAction,
  updateRoleUsersFailureAction,
  updateRoleUsersSuccessAction,
} from "./actions";
import {
  fetchAddOrUpdateRole,
  fetchAddOrUpdateVisibilityCone,
  fetchAllSelectableRoles,
  fetchAllUsers,
  fetchAllVisibilityCones,
  fetchDeleteRole,
  fetchDeleteVisibilityCone,
  fetchGetRoleNewVisibilityCone,
  fetchsendModifiedRoles,
  fetchUserRoles,
} from "./services";

const fetchGetRoleNewVisibilityConeEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.FETCH_LOAD_ROLES_NEW_VISIBILITY_CONE),
    mergeMap((action: any) =>
      fetchGetRoleNewVisibilityCone().pipe(
        map((response: any) => loadRolesNewVisibilityConeSuccess(response)),
        catchError((error: any) => of(loadRolesNewVisibilityConeFailure(error)))
      )
    )
  );

const fetchAllUsersEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.FETCH_ALL_USERS),
    mergeMap((action: any) =>
      fetchAllUsers(action.payload).pipe(
        map((response: any) => fetchAllUsersSuccessAction(response)),
        catchError((error: any) => of(fetchAllUsersFailureAction(error)))
      )
    )
  );

const fetchUserRolesEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.FETCH_USER_ROLES),
    mergeMap((action: any) =>
      fetchUserRoles(action.payload).pipe(
        map((response: any) => fetchUserRolesSuccessAction(response)),
        catchError((error: any) => of(fetchUserRolesFailureAction(error)))
      )
    )
  );

const fetchSelectableRolesEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.FETCH_SELECTABLE_ROLES),
    mergeMap(() =>
      fetchAllSelectableRoles("").pipe(
        map((response: any) => fetchSelectableRolesSuccessAction(response)),
        catchError((error: any) => of(fetchSelectableRolesFailureAction(error)))
      )
    )
  );

const fetchsendModifiedRolesEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.SEND_MODIFIED_ROLES),
    mergeMap((action: any) =>
      fetchsendModifiedRoles(action.payload).pipe(
        map((response: any) => sendModifiedRolesSuccessAction(response)),
        catchError((error: any) => of(sendModifiedRolesFailureAction(error)))
      )
    )
  );

// ROLES MANAGEMENT
const fetchRolesManagementRolesEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.LOAD_ROLES_MANAGEMENT_ROLES),
    mergeMap(() =>
      fetchAllSelectableRoles("").pipe(
        map((response: any) => loadRolesManagementRolesSuccessAction(response)),
        catchError((error: any) =>
          of(loadRolesManagementRolesFailureAction(error))
        )
      )
    )
  );
const fetchRolesManagementVisibilityConesEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.LOAD_ROLES_MANAGEMENT_VISIBILITY_CONES),
    mergeMap(() =>
      fetchAllVisibilityCones().pipe(
        map((response: any) =>
          loadRolesManagementVisibilityConesSuccessAction(response)
        ),
        catchError((error: any) =>
          of(loadRolesManagementVisibilityConesFailureAction(error))
        )
      )
    )
  );

const fetchCreateOrUpdateRoleEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.CREATE_OR_UPDATE_ROLE_ACTION),
    mergeMap((action: any) =>
      fetchAddOrUpdateRole(action.payload).pipe(
        map((response: any) => createOrUpdateRoleSuccessAction(response)),
        catchError((error: any) => of(createOrUpdateRoleFailureAction(error)))
      )
    )
  );

const fetchDeleteRoleEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.DELETE_ROLE_ACTION),
    mergeMap((action: any) =>
      fetchDeleteRole(action.payload).pipe(
        map((response: any) => deleteRoleSuccessAction(response)),
        catchError((error: any) => of(deleteRoleFailureAction(error)))
      )
    )
  );

const fetchCreateOrUpdateVisibilityConeEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.CREATE_OR_UPDATE_VISIBILITY_CONE),
    mergeMap((action: any) =>
      fetchAddOrUpdateVisibilityCone(action.payload).pipe(
        map((response: any) =>
          createOrUpdateVisibilityConeSuccessAction(response)
        ),
        catchError((error: any) =>
          of(createOrUpdateVisibilityConeFailureAction(error))
        )
      )
    )
  );

const fetchDeleteVisibilityConeEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.DELETE_VISIBILITY_CONE),
    mergeMap((action: any) =>
      fetchDeleteVisibilityCone(action.payload).pipe(
        map((response: any) => deleteVisibilityConeSuccessAction(response)),
        catchError((error: any) => of(deleteVisibilityConeFailureAction(error)))
      )
    )
  );

// ROLE USERS
const fetchGetRoleUsersUsersEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_ROLE_USERS_USERS_ACTION),
    mergeMap((action: any) =>
      fetchAllUsers(action.payload).pipe(
        map((response: any) => getRoleUsersUsersSuccessAction(response)),
        catchError((error: any) => of(getRoleUsersUsersFailureAction(error)))
      )
    )
  );

const fetchGetRoleUsersSelecetedUsersEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_ROLE_USERS_SELECTED_USERS_ACTION),
    mergeMap((action: any) =>
      fetchAllSelectableRoles(action.payload).pipe(
        map((response: any) =>
          getRoleUsersSelectedUsersSuccessAction(response)
        ),
        catchError((error: any) =>
          of(getRoleUsersSelectedUsersFailureAction(error))
        )
      )
    )
  );

const fetchUpdateRoleUsersEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.UPDATE_ROLE_USERS_ACTION),
    mergeMap((action: any) =>
      fetchAddOrUpdateRole(action.payload).pipe(
        map((response: any) => updateRoleUsersSuccessAction(response)),
        catchError((error: any) => of(updateRoleUsersFailureAction(error)))
      )
    )
  );

export default [
  fetchAllUsersEpic,
  fetchUserRolesEpic,
  fetchSelectableRolesEpic,
  fetchsendModifiedRolesEpic,
  fetchRolesManagementRolesEpic,
  fetchRolesManagementVisibilityConesEpic,
  fetchCreateOrUpdateRoleEpic,
  fetchDeleteRoleEpic,
  fetchGetRoleUsersUsersEpic,
  fetchGetRoleUsersSelecetedUsersEpic,
  fetchCreateOrUpdateVisibilityConeEpic,
  fetchDeleteVisibilityConeEpic,
  fetchUpdateRoleUsersEpic,
  fetchGetRoleNewVisibilityConeEpic,
];
